import { forwardRef, useEffect, useState } from 'react';

import { getDashboardPanels } from '../../services/dashboardService';
import { getMetadata, IMetadata } from '../../services/metadataService';
import ChartPanel from './ChartPanel';
import { useSetAtom } from 'jotai';
import {
  errorMessageAtom,
  isInProgressAtom,
} from '../../atoms/messageBarAtoms';

export interface IContractorsPanelRef {
  Resize: (width: number, height: number) => void;
}

const ContractorPanel = () => {
  const setErrorMessage = useSetAtom(errorMessageAtom);
  const setIsInProgress = useSetAtom(isInProgressAtom);
  const [metadata, setMetadata] = useState<IMetadata>();

  const fetchData = async () => {
    setIsInProgress(true);
    const abortController = new AbortController();

    try {
      const data: IMetadata = await getMetadata(abortController, 'Contractor');
      setMetadata(data);
    } catch (error: any) {
      setErrorMessage(error.message);
    } finally {
      setIsInProgress(false);
    }
    return () => {
      abortController.abort();
    };
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <ChartPanel
      getDashboardPanelData={async (
        abortController: AbortController,
        options: string
      ) => {
        return await getDashboardPanels(abortController, 'Contractor', options);
      }}
      getOptions={() => {
        const options = [
          { key: 'WO', text: 'Work #' },
          ...(metadata?.fields
            .filter((f) => f.fieldType != 'Image')
            .map((f) => ({ key: f.name, text: f.label })) ?? []),
        ];
        return options;
      }}
    />
  );
};

export default forwardRef(ContractorPanel);
